<template>
  <zbm-multi-view-layout :onBackClick="onBackClick">
    <!-- Title -->
    <template v-slot:title><span class="fa-solid fa-person-walking"></span></template>
    <!-- Heading Text/Content -->
    <template v-slot:heading>{{ t('gait_walking_progress') }}</template>
    <!-- Daily Walking Goal Data -->
    <template v-slot:default></template>
  </zbm-multi-view-layout>
</template>

<script lang="ts" setup>
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';

const router = useRouter();
const { t } = useI18n();

function onBackClick() {
  router.push({ name: 'Dashboard.Home' });
}
</script>
